import { Text } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import { iconSize } from '../../../../../constants/icon.constants';
import Icon from '../../../../@shared/icon';
import { TGroupRowItemProps } from '../../../types/index.types';
import SubvalueRow from './subValueRow';

const DynamicHeadingTag = ({ tag, className, children }) => React.createElement(tag || 'div', { className }, children);

const GroupRow: FC<TGroupRowItemProps> = (props) => {
  const { model, obj, index, toggleRow, expandedRows, showHiddenRightCells } = props;
  const hide = !expandedRows.includes(index);
  return (
    <>
      <tr className="model-detail-specification-table__spec-category-row" onClick={(): void => toggleRow(index)}>
        <td
          className="model-detail-specification-table__left-most-cell model-detail-specification-table__spec-category-row-cell"
          colSpan={model.hideRowsHeader ? model.nOfVisibleColumn : model.nOfVisibleColumn + 1}
        >
          <DynamicHeadingTag
            className={`
                  model-detail-specification-table__spec-category-row__inner-box
                  ${hide ? 'model-detail-specification-table__spec-category-row__inner-box--border-visible' : ''}
              `}
            tag={model.groupHeadingTag}
          >
            <Icon
              iconName={hide ? 'action-plus' : 'action-minus'}
              size={iconSize.mbl}
              extraClassName={hide ? 'table-plus-icon' : 'table-minus-icon'}
            />
            {obj.title && <Text field={obj.title} editable={true} />}
          </DynamicHeadingTag>
        </td>
      </tr>
      {obj.items &&
        obj.items.map((subObj, accIndex, subArr) => (
          <SubvalueRow
            key={subObj.title?.value || subObj.groupName?.value || `subValueRow-${accIndex}`}
            model={model}
            subObj={subObj}
            hide={hide}
            subArr={subArr}
            accIndex={accIndex}
            index={index}
            expandedRows={expandedRows}
            showHiddenRightCells={showHiddenRightCells}
          />
        ))}
    </>
  );
};

export default GroupRow;
